"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../APButton"));
var _APIcon = _interopRequireDefault(require("../APIcon"));
var _fileHelpers = require("../../../helpers/fileHelpers");
var _formValidations = require("../../../helpers/formValidations");
require("./APUpload.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClass = 'ap-upload';
var APUploadInner = /*#__PURE__*/function (_React$Component) {
  function APUploadInner() {
    var _this;
    _classCallCheck(this, APUploadInner);
    _this = _callSuper(this, APUploadInner);
    _defineProperty(_this, "onChange", function (e) {
      var _this$props = _this.props,
        name = _this$props.input.name,
        customChange = _this$props.customChange;
      var file = e.target.files[0];
      if (file) {
        (0, _fileHelpers.readFile)(file, function (imgSrc) {
          customChange(name, {
            file: file,
            imgSrc: imgSrc
          });
          setTimeout(function () {
            return _this.setState({
              file: file,
              imgSrc: imgSrc,
              hasFile: true
            });
          });
        });
      } else {
        _this.setState({
          file: null,
          imgSrc: null,
          hasFile: false
        });
        customChange(name, null);
      }
    });
    _defineProperty(_this, "clearField", function () {
      var onChange = _this.props.input.onChange;
      _this.setState({
        file: null,
        imgSrc: null
      });
      onChange(null);
    });
    _defineProperty(_this, "onFocus", function () {
      _this.setState({
        focused: true,
        hasFocused: true
      });
    });
    _defineProperty(_this, "onBlur", function () {
      _this.setState({
        focused: false
      });
    });
    _defineProperty(_this, "isImage", function (fileName) {
      var parts = fileName.split('.');
      var ext = parts[parts.length - 1];
      return ['jpg', 'jpeg', 'png', 'gif'].includes(ext);
    });
    _this.state = {
      file: null,
      hasFocused: false,
      focused: false,
      hasFile: false
    };
    return _this;
  }
  _inherits(APUploadInner, _React$Component);
  return _createClass(APUploadInner, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props2 = this.props,
        classModifiers = _this$props2.classModifiers,
        customClass = _this$props2.customClass,
        info = _this$props2.info,
        placeholder = _this$props2.placeholder,
        label = _this$props2.label,
        acceptedFiles = _this$props2.acceptedFiles,
        error = _this$props2.meta.error,
        alt = _this$props2.alt;
      var _this$state = this.state,
        file = _this$state.file,
        hasFocused = _this$state.hasFocused,
        focused = _this$state.focused,
        hasFile = _this$state.hasFile,
        imgSrc = _this$state.imgSrc;
      var bemClasses = (0, _cssClassesHelper.getBEMClasses)(baseClass, customClass);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('', {
          hasFile: hasFile
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group ".concat(bemClasses('wrapper', "".concat(classModifiers, " ").concat(hasFile ? 'hasFile' : '')))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('children', classModifiers)
      }, file && this.isImage(file.name) && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('img-wrapper')
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: imgSrc,
        className: bemClasses('preview'),
        alt: alt
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(bemClasses('label', classModifiers), " ").concat(hasFile ? bemClasses('label', ['hasFile']) : '')
      }, file ? file.name : placeholder, file && /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('cancel-btn', classModifiers),
        onClick: this.clearField
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "cancel",
        classModifiers: "danger",
        customClass: bemClasses('image')
      }))), /*#__PURE__*/_react["default"].createElement("label", {
        className: bemClasses('input-box')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: bemClasses('btn'),
        type: "button"
      }, label), /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        className: bemClasses('input'),
        value: '',
        accept: acceptedFiles
      }))), info && /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-text-muted ".concat(bemClasses('info'))
      }, info), (hasFocused || focused) && hasFile && !file && error && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('error')
      }, t(error)));
    }
  }]);
}(_react["default"].Component);
_defineProperty(APUploadInner, "defaultProps", {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: ''
});
_defineProperty(APUploadInner, "propTypes", {
  name: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].string,
  required: _propTypes["default"].bool
});
var APUploadInnerTranslated = (0, _reactI18next.withTranslation)('core')(APUploadInner);
var APUpload = function APUpload(props) {
  var maxSize = function maxSize(value) {
    var maxSize = props.maxSize;
    if (maxSize) return (0, _formValidations.maxFileSize)(value, maxSize);
  };
  var validators = props.validate ? [].concat(_toConsumableArray(props.validate), [maxSize]) : [maxSize];
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    component: APUploadInnerTranslated
  }, props, {
    validate: validators,
    name: props.name
  }));
};
APUpload.defaultProps = {
  name: '',
  label: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  maxSize: null
};
APUpload.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  classModifiers: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  placeholder: _propTypes["default"].string,
  info: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  autoFocus: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  customChange: _propTypes["default"].func
};
var _default = exports["default"] = APUpload;